import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import config from './config';
import AppRouter, { history } from './routers/AppRouter';
import configureStore from './store/configureStore';
import { setLogin } from './actions/auth';
import { setBranchList } from './actions/branches';
import './index.css';
import * as serviceWorker from './serviceWorker';


const store = configureStore();
const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);

const getBranchList = () => {
  if (config['ORG_CODE']) {
    const org_code = config['ORG_CODE'];
    axios.get(`https://a-eye.ai:8000/branch_list?code=${org_code}`).then((response) => {
      console.log(response);
      const branches = response.data.branches;
      store.dispatch(setBranchList(branches));
      ReactDOM.render(jsx, document.getElementById('root'));
    }).catch((err) => {
      console.log(err);
      history.push('/');
    });
  }
  else {
    const branches = [config];
    store.dispatch(setBranchList(branches));
    ReactDOM.render(jsx, document.getElementById('root'));
  }
};

const renderApp = () => {
  let user = localStorage.getItem('user');
  if (user) {
    user = JSON.parse(user)
    store.dispatch(setLogin(user));
  }
  getBranchList();
};

renderApp();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
